var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / close@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-close",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 11.500000) rotate(-45.000000) translate(-12.000000, -11.500000) translate(6.000000, 5.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6852824,6.46 L0.314397171,6.46 C0.232636549,6.45987825 0.154117507,6.41325472 0.0954631602,6.33 C0.0344365335,6.24337816 7.10542736e-14,6.12433689 7.10542736e-14,6 C7.10542736e-14,5.87566311 0.0344365335,5.75662184 0.0954631602,5.67 C0.154117507,5.58674528 0.232636549,5.54012175 0.314397171,5.54 L11.6852824,5.54 C11.767043,5.54012175 11.845562,5.58674528 11.9042164,5.67 C11.9647173,5.75718532 11.9991527,5.87582436 12,6 C11.9930184,6.24970205 11.8561207,6.44979549 11.6852824,6.46 Z",
    id: "Path",
    transform: "translate(6.000000, 6.000000) rotate(-270.000000) translate(-6.000000, -6.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6852824,6.46 L0.314397171,6.46 C0.232636549,6.45987825 0.154117507,6.41325472 0.0954631602,6.33 C0.0344365335,6.24337816 1.42108547e-14,6.12433689 1.42108547e-14,6 C1.42108547e-14,5.87566311 0.0344365335,5.75662184 0.0954631602,5.67 C0.154117507,5.58674528 0.232636549,5.54012175 0.314397171,5.54 L11.6852824,5.54 C11.767043,5.54012175 11.845562,5.58674528 11.9042164,5.67 C11.9647173,5.75718532 11.9991527,5.87582436 12,6 C11.9930184,6.24970205 11.8561207,6.44979549 11.6852824,6.46 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4fa7db3fa7ef5084a865c849778c7925.svg";
export { ForwardRef as ReactComponent };